import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "register-background" }
const _hoisted_3 = {
  key: 0,
  class: "buttons"
}
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, "Register", -1)),
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
          placeholder: "Username",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.username]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
          placeholder: "Email",
          required: "",
          type: "email"
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
          placeholder: "Password",
          required: "",
          type: "password"
        }, null, 512), [
          [_vModelText, _ctx.password]
        ]),
        (!_ctx.message)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Button, { type: "submit" }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("Register")
                ])),
                _: 1
              }),
              _createVNode(_component_Button, {
                color: "red",
                onClick: _ctx.cancel
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.message)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              onClick: _ctx.cancel
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("Return")
              ])),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ], 32),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.message), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}